import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=58823930&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
import style0 from "./Product.vue?vue&type=style&index=0&id=58823930&prod&scoped=true&lang=css"
import style1 from "./Product.vue?vue&type=style&index=1&id=58823930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58823930",
  null
  
)

export default component.exports